import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { GET_COMMULATIVE_EARNING, GET_COMMULATIVE_EARNING_SUCCESS, GET_COMMULATIVE_EARNING_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getCommulativeEarning({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/customer/cumulative-earnings`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: GET_COMMULATIVE_EARNING_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_COMMULATIVE_EARNING_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_COMMULATIVE_EARNING_ERROR, payload: error });
  }
}

export function* watchgetCommulativeEarning() {
  yield takeEvery(GET_COMMULATIVE_EARNING, getCommulativeEarning);
}

function* getCommulativeEarningSaga() {
  yield all([fork(watchgetCommulativeEarning)]);
}

export default getCommulativeEarningSaga;
